// extracted by mini-css-extract-plugin
module.exports = {"button":"AppDetailsActions_button__QuUtL","menuIcon":"AppDetailsActions_menuIcon__KTBup","openButton":"AppDetailsActions_openButton__13PBy"};